import PracQuizTable from './PracQuizTable';

export default PracQuizTable;
